import clearTime from '@/utils/clear-time-from-date';

export default (date) => {
  const argDate = clearTime(date).getTime();
  const tomorrow = clearTime(new Date());
  tomorrow.setDate(tomorrow.getDate() + 1);

  return tomorrow.getTime() === argDate;
};
